export default class EventBus {
    constructor() {
        this._nextHandler = () => null;
        this._handlers = {};
        this.exec = this.exec.bind(this);
    }
    on(key, handler) {
        const name = key;
        const prev = this._handlers[name];
        if (!prev) {
            this._handlers[name] = (ev) => {
                resolvePromise(this._nextHandler, ev, name)(handler(ev));
            };
        }
        else {
            // wrap existing handler
            this._handlers[name] = function (ev) {
                resolvePromise(prev, ev)(handler(ev));
            };
        }
    }
    exec(key, ev) {
        const name = key;
        const handler = this._handlers[name];
        if (handler) {
            handler(ev);
        }
        else {
            this._nextHandler(name, ev);
        }
    }
    setNext(next) {
        this._nextHandler = next;
    }
}
function resolvePromise(prev, ev, name) {
    return (res) => {
        if (res !== false) {
            if (res && res.then)
                res.then(resolvePromise(prev, ev, name));
            else {
                if (name)
                    prev(name, ev);
                else
                    prev(ev);
            }
        }
    };
}
//# sourceMappingURL=EventBus.js.map